export const formatePercentageValue = (maximum: number, value: number) => {
  if (maximum && value) {
    const percent = (100 / maximum) * value;
    return `${percent} ${100 - percent}`;
  }
  return '0 100';
};
